/*
 * Wishlist Outlet034 — favoritos sem app, via localStorage.
 * - Guarda handles de produto na chave "outlet034:wishlist".
 * - Delegação de evento no document: funciona em cards renderizados depois
 *   (Section Rendering / infinite scroll) sem re-attach de listeners.
 * - Dispara CustomEvent("wishlist:change", {detail:{count}}) para o header.
 * - Idempotente: seguro carregar o script mais de uma vez na mesma página.
 * - Evento `storage` sincroniza abas; dispara `wishlist:ready` ao carregar.
 */
(function () {
  if (window.Outlet034Wishlist) return;

  var KEY = 'outlet034:wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage indisponível — ignora silenciosamente */
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function emitChange() {
    var count = read().length;
    document.dispatchEvent(
      new CustomEvent('wishlist:change', { detail: { count: count } })
    );
    return count;
  }

  function toggle(handle) {
    if (!handle) return false;
    var list = read();
    var i = list.indexOf(handle);
    var active;
    if (i === -1) {
      list.push(handle);
      active = true;
    } else {
      list.splice(i, 1);
      active = false;
    }
    write(list);
    emitChange();
    return active;
  }

  function remove(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i !== -1) {
      list.splice(i, 1);
      write(list);
      emitChange();
    }
  }

  // Rótulos acessíveis vêm do próprio botão (data-label-*), definidos nas
  // configurações do tema — nada de texto fixo aqui.
  function paintButton(btn, active) {
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = btn.getAttribute(active ? 'data-label-remove' : 'data-label-add');
    if (label) btn.setAttribute('aria-label', label);
  }

  // Hidrata o estado visual de todos os botões presentes no DOM.
  function hydrate(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      paintButton(btn, has(btn.getAttribute('data-wishlist-handle')));
    }
  }

  // Delegação: um único listener no document cobre cards atuais e futuros.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    var handle = btn.getAttribute('data-wishlist-handle');
    var active = toggle(handle);
    // Repinta todos os botões do mesmo produto (o card pode aparecer 2x).
    var same = document.querySelectorAll(
      '[data-wishlist-toggle][data-wishlist-handle="' + handle + '"]'
    );
    for (var i = 0; i < same.length; i++) paintButton(same[i], active);
  });

  // Formata centavos usando a moeda ativa da loja (sem hardcode de "R$").
  function formatMoney(cents) {
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'BRL';
    var locale = document.documentElement.lang || 'pt-BR';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  window.Outlet034Wishlist = {
    key: KEY,
    getAll: read,
    has: has,
    toggle: toggle,
    remove: remove,
    hydrate: hydrate,
    count: function () {
      return read().length;
    },
    formatMoney: formatMoney,
  };

  // Re-hidrata o estado dos corações após re-render (Section Rendering /
  // infinite scroll). Quem re-renderiza dispara `wishlist:hydrate`.
  document.addEventListener('wishlist:hydrate', function () {
    hydrate();
  });

  // Sincroniza entre abas: outra aba alterou a lista -> repinta e avisa
  // header/página de favoritos.
  window.addEventListener('storage', function (event) {
    if (event.key !== KEY && event.key !== null) return;
    hydrate();
    emitChange();
  });

  hydrate();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hydrate();
      emitChange();
    });
  } else {
    emitChange();
  }
  document.dispatchEvent(new CustomEvent('wishlist:ready'));
})();
